module.exports = __webpack_public_path__ + "img/Cumulative - Impact assessment.f35dc781.svg";